import "react-tooltip/dist/react-tooltip.css";

import {
  ArrowDownIcon,
  ArrowDownTrayIcon,
  ArrowPathIcon,
  ArrowPathRoundedSquareIcon,
  ArrowTopRightOnSquareIcon,
  ArrowUpIcon,
  ArrowsPointingOutIcon,
  BellAlertIcon,
  CalculatorIcon,
  CalendarDaysIcon,
  ChatBubbleBottomCenterTextIcon,
  ChatBubbleOvalLeftEllipsisIcon,
  CheckIcon,
  ClipboardDocumentCheckIcon,
  ClipboardDocumentListIcon,
  Cog8ToothIcon,
  DocumentDuplicateIcon,
  EyeIcon,
  HandThumbUpIcon,
  InboxStackIcon,
  LockOpenIcon,
  MagnifyingGlassPlusIcon,
  PaperAirplaneIcon,
  PaperClipIcon,
  PencilSquareIcon,
  ReceiptPercentIcon,
  RocketLaunchIcon,
  TableCellsIcon,
  TrashIcon,
  UserIcon,
  UserPlusIcon,
  UsersIcon,
  XMarkIcon,
} from "@heroicons/react/24/outline";
import { StarIcon, StopCircle } from "lucide-react";
import { classNames, wrapClick } from "utils";

import { FC } from "react";
import { ModalActions } from "utils/types";
import { Show } from "components/core";

// replace actions from modal actions to actions
// const Actions = ;

export type Action = Exclude<
  ModalActions,
  | "create-treaty-endorsement"
  | "remove-treaty-endorsement"
  | "update-treaty-endorsement"
  | "view-treaty-endorsement"
  | "remove-adjustment-statement"
  | "update-adjustment-statement"
>;

const ActionIcons: { [key in Action]: typeof EyeIcon } = {
  approve: ClipboardDocumentCheckIcon,
  "portfolio-statement": DocumentDuplicateIcon,
  assign: UserPlusIcon,
  attach: PaperClipIcon,
  calculate: CalculatorIcon,
  download: ArrowDownTrayIcon,
  create: UserPlusIcon,
  "create-target": UserPlusIcon,
  "sheet-report": TableCellsIcon,
  "lock-open": LockOpenIcon,
  "thumbs-up": HandThumbUpIcon,
  premium: StarIcon,
  "cancel-premium": StopCircle,
  recreate: ArrowPathIcon,
  chat: ChatBubbleBottomCenterTextIcon,
  configure: Cog8ToothIcon,
  distribute: InboxStackIcon,
  reassign: UserIcon,
  reject: ArrowPathRoundedSquareIcon,
  resolve: ClipboardDocumentListIcon,
  schedule: CalendarDaysIcon,
  send: PaperAirplaneIcon,
  update: PencilSquareIcon,
  view: EyeIcon,
  expand: ArrowsPointingOutIcon,
  goto: ArrowTopRightOnSquareIcon,
  clone: DocumentDuplicateIcon,
  investigate: MagnifyingGlassPlusIcon,
  remove: TrashIcon,
  assignPercentage: ReceiptPercentIcon,
  close: XMarkIcon,
  alert: BellAlertIcon,
  "update-layer": PencilSquareIcon,
  "send-layer": PaperAirplaneIcon,
  "view-layer": EyeIcon,
  export: ArrowDownIcon,
  import: ArrowUpIcon,
  "view-associate": EyeIcon,
  "update-associate": PencilSquareIcon,
  "remove-associate": TrashIcon,
  participants: UsersIcon,
  accept: CheckIcon,
  comment: ChatBubbleOvalLeftEllipsisIcon,
};

interface ActionButtonProps {
  action: Action;
  onClick: (...val: any) => any;
  disabled?: boolean;
  tooltip?: string;
  extraClassName?: string;
  count?: number;
  callBack?: (values: any) => any;
}

const ActionButton: FC<ActionButtonProps> = ({
  action,
  onClick,
  tooltip,
  extraClassName = "",
  disabled = false,
  count = 0,
  callBack,
}) => {
  const Icon = ActionIcons[action];

  const handleClick = () => {
    if (callBack) {
      callBack(action);
    }
    onClick();
  };

  return (
    <button
      data-tooltip-delay-show={50}
      data-tooltip-id="global-tooltip"
      data-tooltip-content={tooltip || action}
      type="button"
      onClick={wrapClick(handleClick)}
      disabled={disabled}
      className={classNames(
        disabled
          ? "cursor-not-allowed text-gray-500 hover:bg-gray-300"
          : "text-gray-500 hover:bg-gray-300 hover:text-gray-900",
        "inline-flex items-center rounded-full border relative border-transparent p-1 disabled:cursor-not-allowed focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2",
        extraClassName
      )}
    >
      <Icon className="h-5 w-5" aria-hidden="true" />
      <Show if={count > 0}>
        <div className="bg-white absolute -top-1 -left-1 rounded-full h-4  p-0.5 flex items-center justify-center text-xs text-gray-500">
          <span className="text-xs font-semibold">{count}</span>
        </div>
      </Show>
    </button>
  );
};
export default ActionButton;
